import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export const GoogleTagManager = t0 => {
  const $ = _c(2);
  const {
    gtmId
  } = t0;
  const t1 = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window, document, 'script', 'dataLayer', '${gtmId}')`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Script dangerouslySetInnerHTML={{
      __html: t1
    }} id="gtm_script" strategy="lazyOnload" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};